import {
  Route,
  Routes as RoutesComponent,
  useLocation,
  Navigate,
} from "react-router-dom";
import Routes from "./routes";
import { useUserInfo } from "@store/hooks";
// import styled from "styled-components";
// import backIcon from "@assets/images/chevron_left.png";

/*
const BackIcon = styled.img`
  width: 36px;
  height: 36px;
  position: absolute;
  top: 10px;
  left: 10px;
  cursor: pointer;
`;
*/

const Routers = () => {
  const userInfo = useUserInfo();

  // const location = useLocation();

  const location = useLocation();

  return (
    <>
      <RoutesComponent>
        {Routes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              route.sessionRequired ? (
                userInfo.name.length > 0 ? (
                  <route.component />
                ) : (
                  <Navigate
                    to={{ pathname: "/", search: location.search }}
                    replace
                  />
                )
              ) : (
                <route.component />
              )
            }
          />
        ))}
      </RoutesComponent>
      {/* location.pathname === "/" ? null : (
        <BackIcon src={backIcon} onClick={() => history.goBack()} />
      ) */}
    </>
  );
};

export default Routers;
